import { useTranslation } from "react-i18next";
import { Loader } from "@/shared/components/ui/loader";

interface PageLoaderProps {
    message?: string;
}

export function PageLoader({ message }: PageLoaderProps) {
    const { t } = useTranslation("shared");
    const displayMessage = message ?? t("loader.loading");
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
            <div className="flex flex-col items-center gap-4">
                <Loader size="lg" />
                <p className="text-slate-600 font-medium">{displayMessage}</p>
            </div>
        </div>
    );
}

interface SectionLoaderProps {
    message?: string;
    size?: "sm" | "md" | "lg";
}

export function SectionLoader({ message, size = "md" }: SectionLoaderProps) {
    return (
        <div className="flex flex-col items-center justify-center py-12">
            <Loader size={size} />
            {message && (
                <p className="mt-4 text-sm text-muted-foreground">{message}</p>
            )}
        </div>
    );
}
